import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateReferrer, updateInvitationId } from '../../reducers/graph';
import { IdentificationModale } from '../onboarding/IdentificationModale';
import { useInvitationBySlug } from '../../hooks/useInvitationBySlug';
import {} from '../../hooks/patient.hooks';
import { Spinner } from '@/components/ui/spinner';
import { UnavailableQuestionnairePage } from '../onboarding/UnavailableQuestionnairePage';

export const Unsubscribe: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const dispatch = useDispatch();

  const {
    data: invitation,
    isLoading: invitationLoading,
    isError: invitationError,
  } = useInvitationBySlug(slug || '');

  useEffect(() => {
    // Set referrer for analytics
    dispatch(updateReferrer('unsub'));

    if (invitation?.id) {
      dispatch(updateInvitationId(invitation.id));
    }
  }, [dispatch, invitation?.id]);

  if (invitationLoading) {
    return (
      <div className=" h-full bg-gray-50 flex items-center justify-center">
        <Spinner className="size-10" aria-label="Chargement" />
      </div>
    );
  }

  if (invitationError || !invitation) {
    return <UnavailableQuestionnairePage pastConsultation={false} />;
  }

  return (
    <IdentificationModale comingFromUnsubscribe invitationId={invitation.id} />
  );
};
